module.exports = __webpack_public_path__ + "static/media/search-by-algolia-light-background.57103ac6.svg";